<script setup lang="ts">
/**
 * リプライ情報 > 投稿内容。
 */

import { defineProps } from "vue";

interface Props {
	/**
	 * リプライ投稿内容。
	 */
	contents: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<p class="revico-community-talk-reply-details--contents" v-html="contents"></p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	.revico-community-talk-reply-details {
		&--contents {
			width: 100%;
			white-space: pre-wrap;
			overflow-wrap: break-word;
		}
	}
}
</style>
